<!--
 * @Description: 免金额优惠券
 * @Version: 
 * @Autor: mxn
 * @Date: 2019-08-16 18:16:29
 * @LastEditors: mxn
 * @LastEditTime: 2019-09-01 13:01:39
 -->
<template>
	<div>
		<div class="table-page-search-wrapper" style="border-bottom: 1px solid #eee;">
			<a-card style="padding-top: 24px;">
				<a-form layout="inline" :form="form">
					<a-row :gutter="48">
						<a-col :md="6" :sm="24">
							<a-form-item label="优惠券" :labelCol="labelCol" :wrapperCol="wrapperCol">
								<a-select :getPopupContainer="trigger => trigger.parentNode" @change="handleSelectChange" placeholder="请选择优惠券"
								 v-decorator="['SelectCoupon', {rules: [{ required: true, message: '请选择优惠券.' }]}]">
									<a-select-option v-for="(item, index) in couponList" :key="index" :value="item.u_couponsetting_id">{{item.couponame}}</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :md="9" :sm="24">
							<a-row>
								<a-col :md="8" :sm="24">
									<a-form-item label="剩余数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
										<span v-if="couponInfo.totalcount==0&&couponInfo.lifecyc==0" style=" color: green; ">无上限</span>
										<span v-else-if="couponInfo.remaincount>=0" style=" color: green; ">{{couponInfo.remaincount}}</span>
									</a-form-item>
								</a-col>
								<a-col :md="8" :sm="24">
									<a-form-item label="减免金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
										<span style=" color: green; " v-if="couponInfo.remaincount>=0">{{couponInfo.discount}}</span> 元
									</a-form-item>
								</a-col>
								<a-col :md="8" :sm="24">
									<a-form-item label="有效时段" :labelCol="labelCol" :wrapperCol="wrapperCol">
										<span style=" color: green; ">{{couponInfo.theterm}}</span> 小时
									</a-form-item>
								</a-col>
								<!-- <a-col :md="11" :sm="24" style="display: flex;padding-left:17px;">
                  <span style="font-size:24px;color:yellowgreen;margin-right: 5px;margin-top: -3px;">
                    <a-icon type="dollar"></a-icon>
                  </span>
                  <a-form-item label="余额" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <span style="font-size:20px;font-weight: bold;">
                      ￥ {{surplusmoney}}</span>
                  </a-form-item>
                </a-col> -->
							</a-row>
						</a-col>
						<a-col :md="5" :sm="24">
							<a-form-item label="有无车牌号" :labelCol="labelCol" :wrapperCol="wrapperCol">
								<a-radio-group @change="onChange" v-model="phoneORlicense" defaultValue="true">
									<a-radio-button value="true">有车牌</a-radio-button>
									<a-radio-button value="false">无车牌</a-radio-button>
								</a-radio-group>
							</a-form-item>
						</a-col>
						<a-col :md="4" :sm="24">
							<a-button type="primary" @click="handleCouponList()">查看优惠券记录</a-button>
						</a-col>
					</a-row>
				</a-form>
			</a-card>
		</div>

		<div style="margin-top:20px;">
			<a-row :gutter="48">
				<a-col :md="10" :sm="24">
					<a-card title="已入场车辆">
						<div slot="extra">
							<div class="table-page-search-wrapper">
								<a-form layout="inline" :form='form'>
									<a-row :gutter="48">
										<a-col :md="12" :sm="24" style="padding-right:0">
											<a-form-item v-show="phoneORlicense !== 'false'" label="车牌号码" style="margin-bottom:0">
												<a-input v-model="queryPlateParam.licenseplate" placeholder @change="getLice" />
											</a-form-item>
											<a-form-item v-show="phoneORlicense === 'false'" label="手机号" style="margin-bottom:0">
												<a-input v-model="queryPhoneParam.phone" placeholder @change='getPhone' />
											</a-form-item>
										</a-col>
										<a-col :md="6" :sm="24">
											<span class="table-page-search-submitButtons" style="margin-bottom:0">
												<a-button v-show="phoneORlicense !== 'false'" @click="getLice">查询</a-button>
												<a-button v-show="phoneORlicense === 'false'" @click="getPhone">查询</a-button>
												<a-button type="primary" v-if="isShow" @click="onNullSend()" style="margin-left:20px;">派发</a-button>
												<a-icon type="reload" class="relocdIcon" @click="refreshTable(1)" style="margin-left: 40px;" />
											</span>
										</a-col>
									</a-row>
								</a-form>
							</div>
						</div>

						<s-table ref="table1" size="default" rowKey="u_coupons_id" v-show="phoneORlicense !== 'false'" :columns="columnsLice"
						 :data="loadPlateData" :showPagination="showPagination" :customRow="setRow" :scroll="{y:400}">
							<span slot="orderstatus" slot-scope="text,record">
								<template v-if="text==0">
									<span color="green">初始化</span>
								</template>
								<template v-if="text==6">
									<span color="green">已支付</span>
								</template>
								<template v-if="text==7&&record.out==0">
									<span color="red">已入场</span>
								</template>
								<template v-if="text==7&&record.out==1">
									<span color="red">已入场(已到出口)</span>
								</template>
								<template v-if="text==8">
									<span color="red">已超时</span>
								</template>
								<template v-if="text==9">
									<span color="red">已支付(超时)</span>
								</template>
							</span>
							<span slot="createdate1" slot-scope="text,record">
								{{timeFn(text,record.sysdate)}}
							</span>
							<span slot="operate" slot-scope="text, record,index">
								<template>
									<a-popconfirm title="确认派发吗?" @confirm="() => onSend(index,record)">
										<a :id="'send'+index">派发</a>
									</a-popconfirm>
								</template>
							</span>
						</s-table>

						<s-table v-show="phoneORlicense === 'false'" ref="tablePhone" size="default" rowKey="u_coupons_id" :columns="columnsMobile"
						 :data="loadNullData" :showPagination="showPagination" :customRow="setRow" :scroll="{ y:400}">
							<span slot="orderstatus" slot-scope="text,record">
								<template v-if="text==0">
									<span color="green">初始化</span>
								</template>
								<template v-if="text==6">
									<span color="green">已支付</span>
								</template>
								<template v-if="text==7&&record.out==0">
									<span color="red">已入场</span>
								</template>
								<template v-if="text==7&&record.out==1">
									<span color="red">已入场(已到出口)</span>
								</template>
								<template v-if="text==8">
									<span color="red">已超时</span>
								</template>
								<template v-if="text==9">
									<span color="red">已支付(超时)</span>
								</template>
							</span>
							<span slot="createdate1" slot-scope="text,record">
								{{timeFn(text,record.sysdate)}}
							</span>
							<span slot="operate" slot-scope="text, record,index">
								<template>
									<a-popconfirm title="确认派发吗?" @confirm="() => onSend(index,record)">
										<a :id="'sendPhone'+index">派发</a>
									</a-popconfirm>
								</template>
							</span>
						</s-table>
					</a-card>
				</a-col>
				<a-col :md="14" :sm="24">
					<a-card title="优惠券未使用">
						<div slot="extra">
							<a-icon type="reload" class="relocdIcon" @click="refreshTable(2)" />
						</div>
						<s-table ref="table" size="default" rowKey="u_coupons_id" :columns="allColumnsLice" :data="loadData"
						 :showPagination="showPagination" :scroll="{ y:400}">
							<template slot="serial" slot-scope="text, record, index">{{ index + 1 }}</template>
							<span slot="operate" slot-scope="text, record,index">
								<template>
									<a-popconfirm title="确认删除吗?" @confirm="() => onDelete(record)">
										<a>删除</a>
									</a-popconfirm>
								</template>
							</span>
						</s-table>
					</a-card>
				</a-col>
			</a-row>
		</div>
	</div>
</template>

<script>
	import {
		getCouponsInfo,
		getLicenseplateInfo,
		getLicenseplateInfoByMobile,
		AddCoupons,
		getLicenseplateLikeQuery,
		getLicenseplateLikeQueryByPhone,
		getCouponsList,
		getSelectCouponsList,
		getOrderBylp,
		getOrderByPhone,
		deletCoupons
	} from '@/api/SellerCoupons'
	import {
		message,
		notification
	} from 'ant-design-vue'
	import {
		MillisecondToDate,
		timeFn,
		getLocalTime
	} from '@/utils/util'
	import debounce from 'lodash/debounce'
	import moment from 'moment'
	import Badge from 'ant-design-vue/es/badge/Badge'
	import Tag from 'ant-design-vue/es/tag/Tag'
	import STable from '@/components/Table/'
	require('vue-cookies')

	//余额接口
	import {
		getSellersCoupons
	} from '@/api/Main'
	import config from '@/config/defaultSettings.js'

	export default {
		components: {
			Badge,
			Tag,
			STable
		},
		data() {
			this.LicenseplateQuery = debounce(this.LicenseplateQuery, 300)
			return {
				labelCol: {
					lg: {
						span: 6
					},
					sm: {
						span: 7
					}
				},
				wrapperCol: {
					lg: {
						span: 17
					},
					sm: {
						span: 7
					}
				},

				//优惠券信息
				couponInfo: {},
				extraLicenseInfo: '暂无车辆信息',
				phoneORlicense: 'true',
				form: this.$form.createForm(this),
				form1: this.$form.createForm(this),
				licenseSelectData: [],
				phoneSelectData: [],
				spinning: true,
				spinning_lod: false,

				switchDisabled: true,
				//优惠券下拉数据
				couponList: {},
				//优惠券信息
				couponID: '',
				//账户余额
				surplusmoney: '',

				websock: null,
				baseWsUrl: config.iXiaoZha.wsUrlConfig + '/adminwebsocket/tokenId/',
				wsUrl: '',
				ws: true,

				//查询车牌号
				queryPlateParam: {},
				queryPlateParam1: {
					licenseplate: 'O'
				},
				queryPhoneParam: {},

				plateList: [],
				phoneList: [],
				isShow: false,
				tempPlateData: {},
				tempPhoneData: {},

				queryParam_createdate: '',
				// 查询参数
				queryParam: {
					createdate: ''
				},
				// 高级搜索 展开/关闭
				advanced: false,

				// 表头
				columnsLice: [{
						key: '1',
						title: '入场时间',
						dataIndex: 'createdate',
						width: '31%',
					}, {
						key: '2',
						title: '车牌号',
						dataIndex: 'licenseplate',
						width: '25%',
					},
					{
						key: '2',
						title: '已停时长',
						dataIndex: 'createdate',
						width: '27%',
						scopedSlots: {
							customRender: 'createdate1'
						},
					},
					// {
					//       key: '3',
					//       title: '状态',
					//       dataIndex: 'orderstatus',
					//       width: '26%',
					//       scopedSlots: {
					//         customRender: 'orderstatus'
					//       },
					//     },
					{
						key: '4',
						title: '操作',
						dataIndex: 'operate',
						scopedSlots: {
							customRender: 'operate'
						},
						width: '18%',
					}
				],
				loadPlateData: parameter => {
					if (this.queryPlateParam.licenseplate == undefined && this.tempValue == true) {
						this.tempValue = false
						return getOrderBylp(Object.assign(parameter, this.queryPlateParam1)).then(res => {
							this.plateList = res.result.data;
							if (res.result.data.length == 0) {
								return {
									data: [],
									pageSize: 10,
									pageNo: 1,
									totalPage: 1,
									totalCount: 10
								}
							} else {
								return res.result
							}
						})
					} else {
						return getOrderBylp(Object.assign(parameter, this.queryPlateParam)).then(res => {
							this.plateList = res.result.data;
							if (res.result.data.length == 0) {
								return {
									data: [],
									pageSize: 10,
									pageNo: 1,
									totalPage: 1,
									totalCount: 10
								}
							} else {
								return res.result
							}

						})
					}
				},
				loadNullData: () => {
					return new Promise(resolve => {
						resolve({
							data: [],
							pageSize: 10,
							pageNo: 1,
							totalPage: 1,
							totalCount: 10
						})
					}).then(res => {
						return res
					})
				},
				columnsMobile: [{
						key: '1',
						title: '入场时间',
						dataIndex: 'intime',
						width: '31%',
					},
					{
						key: '2',
						title: '已停时长',
						dataIndex: 'createdate',
						width: '27%',
						scopedSlots: {
							customRender: 'createdate1'
						},
					},
					{
						key: '3',
						title: '手机号',
						dataIndex: 'mobile',
						scopedSlots: {
							customRender: 'mobile'
						},
						width: '26%',
					},
					// {
					//         key: '3',
					//         title: '状态',
					//         dataIndex: 'orderstatus',
					//         width: '26%',
					//         scopedSlots: {
					//           customRender: 'orderstatus'
					//         },
					//       },
					{
						key: '4',
						title: '操作',
						dataIndex: 'operate',
						scopedSlots: {
							customRender: 'operate'
						},
						width: '18%',
					}
				],
				loadPhoneData: parameter1 => {
					return getOrderByPhone(Object.assign(parameter1, this.queryPhoneParam)).then(res => {
						this.phoneList = res.result.data;
						if (res.result.data.length == 0) {
							return {
								data: [],
								pageSize: 10,
								pageNo: 1,
								totalPage: 1,
								totalCount: 10
							}
						} else {
							return res.result
						}

					})
				},
				searchData: {},
				allColumnsLice: [{
						title: '#',
						scopedSlots: {
							customRender: 'serial'
						},
						width: '1%',
					},
					{
						title: '优惠券编号',
						dataIndex: 'couponscode',
						width: '23%',
					},
					{
						title: '优惠卷名称',
						dataIndex: 'couponame',
						width: '20%',
					},
					{
						title: '车牌号码',
						dataIndex: 'licenseplate',
						scopedSlots: {
							customRender: 'licenseplate'
						},
						width: '15%',
					}, {
						title: '手机号码',
						dataIndex: 'mobile',
						width: '16%',
					},
					{
						title: '到期时间',
						dataIndex: 'expirydate',
						width: '16%'
					},
					{
						title: '操作',
						dataIndex: 'operate',
						scopedSlots: {
							customRender: 'operate'
						},
						width: '10%'
					}
				],
				// 加载数据方法 必须为 Promise 对象
				loadData: parameter => {
					//this.queryParam为V-model的提交参数集合
					//需要提交的参数集合
					var paraData = {
						distype: '3',
						isused: 0
					}

					parameter.pageSize = 999

					if (this.queryParam_createdate != '') {
						paraData['dateStart'] = this.queryParam_createdate[0]
						paraData['dateEnd'] = this.queryParam_createdate[1]
					}

					//https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
					//Object.assign() 方法用于将所有可枚举属性的值从一个或多个源对象复制到目标对象。它将返回目标对象。
					return getCouponsList(Object.assign(parameter, Object.assign(paraData, this.queryParam))).then(res => {
						return res.result
					})
				},
				disIndex: -1,
				showPagination: false,

				tempValue: true
			}
		},
		mounted() {
			this.showPagination = false;
			this.couponList.isneedorders = 1;
			this.tempPhoneData = this.loadPhoneData;
			this.tempPlateData = this.loadPlateData;
			getSelectCouponsList({
				couponType: '3'
			}).then(res => {
				this.couponList = res.result;
				this.spinning = false
			})
			// getSellersCoupons('').then(res => {
			//   this.surplusmoney = res.result.sellerfund == 0 ? 0 : res.result.sellerfund.surplusmoney
			// })

		},
		beforeDestroy() {
			this.ws = false
			if (this.websock != null) {
				this.websock.close() //离开路由之后断开websocket连接
			}
		},
		methods: {
			onSend(index, record) {
				let _self = this
				this.form.validateFields((err, values) => {
					if (!err) {
						let a;
						if (this.phoneORlicense !== 'false') {
							a = document.getElementById('send' + index);
						} else {
							a = document.getElementById('sendPhone' + index);
						}
						a.href = 'javascript:void(0)';
						a.style.color = '#999';

						const data = {
							'uCoupons.u_parkingarea_id': record.u_parkingarea_id,
							'uCoupons.u_couponsetting_id': values.SelectCoupon,
							'uCoupons.licenseplate': record.licenseplate,
							'uCoupons.phone': record.mobile,
							'uCoupons.allcount': 1,
							'uCoupons.memo': record.memo
						}
						AddCoupons(data).then(res => {
							if (res.status === 0) {
								notification.success({
									message: '提交成功！',
									description: '页面将在1秒后自动重置'
								})
								setTimeout(() => {
									this.$refs.table.refresh(true);
									if (_self.phoneORlicense !== 'false') {
										_self.$refs.table1.refresh(true);
									} else {
										_self.$refs.tablePhone.refresh(true);
									}
									_self.getCouponsInfo(_self.couponID);
									// getSellersCoupons('').then(res => {
									//   this.surplusmoney = res.result.sellerfund == 0 ? 0 : res.result.sellerfund.surplusmoney
									// })

									this.queryPlateParam = {};
									this.queryPhoneParam = {};
								}, 1000)
							} else {
								notification.error({
									message: '提交失败！',
									description: res.message
								})
							}
						})
					}
				})
			},
			onNullSend() {
				var _self = this;
				this.form.validateFields((err, values) => {
					if (!err) {

						if (_self.phoneORlicense !== 'false') {
							if (_self.queryPlateParam.licenseplate) {
								//验证车牌号
								let v = _self.queryPlateParam.licenseplate;
								let reg =
									/^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/


								if (v.length == 7 || v.length == 8) {
									if (reg.test(v)) {

										this.$confirm({
											title: '确定派发吗?',
											okText: '是',
											cancelText: '否',
											onOk() {
												const data = {
													'uCoupons.u_couponsetting_id': values.SelectCoupon,
													'uCoupons.licenseplate': _self.queryPlateParam.licenseplate,
													'uCoupons.phone': _self.queryPhoneParam.phone,
													'uCoupons.allcount': 1,
													'uCoupons.memo': ''
												}
												AddCoupons(data).then(res => {
													if (res.status === 0) {
														notification.success({
															message: '提交成功！',
															description: '页面将在1秒后自动重置111'
														})
														_self.getCouponsInfo(_self.couponID);
														setTimeout(() => {
															_self.$refs.table1.refresh(true);

															_self.$refs.table.refresh(true);
															 
															// getSellersCoupons('').then(res => {
															//   _self.surplusmoney = res.result.sellerfund == 0 ? 0 : res.result.sellerfund.surplusmoney
															// })
														}, 1000)
													} else {
														notification.error({
															message: '提交失败！',
															description: res.message
														})
													}
												})
											},
											onCancel() {}
										})

									} else {
										alert('请输入正确的车牌号');
									}
								} else {
									alert('请输入正确的车牌号');
								}
							} else {
								alert('请填写车牌号');
							}
						} else {
							if (_self.queryPhoneParam.phone) {
								//验证车牌号
								let m = _self.queryPhoneParam.phone;

								let isRight = m && !/^1\d{10}$/.test(m);

								if (isRight) {
									alert('请填写正确的手机号')
								} else {
									this.$confirm({
										title: '确定派发吗?',
										okText: '是',
										cancelText: '否',
										onOk() {
											const data = {
												'uCoupons.u_couponsetting_id': values.SelectCoupon,
												'uCoupons.licenseplate': _self.queryPlateParam.licenseplate,
												'uCoupons.phone': _self.queryPhoneParam.phone,
												'uCoupons.allcount': 1,
												'uCoupons.memo': ''
											}
											AddCoupons(data).then(res => {
												if (res.status === 0) {
													notification.success({
														message: '提交成功！',
														description: '页面将在1秒后自动重置'
													})
													setTimeout(() => {
														_self.$refs.table.refresh(true);
														_self.$refs.tablePhone.refresh(true);
														_self.getCouponsInfo(_self.couponID);
														// getSellersCoupons('').then(res => {
														//   _self.surplusmoney = res.result.sellerfund == 0 ? 0 : res.result.sellerfund.surplusmoney
														// })
													}, 1000)
												} else {
													notification.error({
														message: '提交失败！',
														description: res.message
													})
												}
											})
										},
										onCancel() {}
									})
								}
							} else {
								alert('请填写手机号');
							}
						}
					}
				})

			},
			getPhone(e) {
				if (e.target.value.length > 11) {
					alert('请输入正确的手机号')
					this.queryPhoneParam.phone = '';
					getOrderByPhone('').then(res => {
						this.phoneList = res.result.data
					})
					this.loadPhoneData = this.tempPhoneData;
					this.$refs.tablePhone.refresh(true);
				} else {

					this.loadPhoneData = this.tempPhoneData;
					this.$refs.tablePhone.refresh(true);
				}

				if (this.couponInfo.isneedorders == 0) {
					this.isShow = true;
				} else {
					this.isShow = false;
				}
			},
			getLice(e) {
				this.queryPlateParam.licenseplate = e.target.value.toUpperCase()
				if (e.target.value.length > 8) {
					alert('请输入正确的车牌号')
					this.queryPlateParam.licenseplate = '';
					getOrderBylp('').then(res => {
						this.plateList = res.result.data
					})
					this.loadPlateData = this.tempPlateData;
					this.$refs.table1.refresh(true);
				} else {
					this.loadPlateData = this.tempPlateData;
					this.$refs.table1.refresh(true);
				}
				if (this.couponInfo.isneedorders == 0) {
					this.isShow = true;
				} else {
					this.isShow = false;
				}
			},
			refreshTable(kind) {
				if (kind == 1) {
					if (this.phoneORlicense !== 'false') {
						this.$refs.table1.refresh(true);
					} else {
						this.$refs.tablePhone.refresh(true);
					}
				} else {
					this.$refs.table.refresh(true);
				}
			},
			onDelete(record) {
				deletCoupons({
					id: record.u_coupons_id
				}).then(res => {
					if (res.status === 0) {
						if(this.couponID != '')
						{
							this.getCouponsInfo(this.couponID);
						}
						this.$message.success('删除成功！')
						
					} else {
						this.$message.error('删除失败！' + res.message)
					}
					this.$refs.table.refresh(true)
				})
			},
			handleCouponList() {
				this.$emit('onCouponList')
			},
			toggleAdvanced() {
				this.advanced = !this.advanced
			},
			onCreatedateChange(date, dateString) {
				this.queryParam_createdate = dateString
			},
			/*中间相关的方法*/
			LicenseplateQuery(value) {
				this.licenseSelectData = []
				getLicenseplateLikeQuery({
					licenseplate: value
				}).then(res => {
					if (res.status === 0) {
						this.licenseSelectData = res.result
					}
				})
			},
			PhoneQuery(value) {
				this.phoneSelectData = []
				getLicenseplateLikeQueryByPhone({
					phone: value
				}).then(res => {
					if (res.status === 0) {
						this.phoneSelectData = res.result
					}
				})
			},
			handleLicenseSearch(value) {
				var v = value.toUpperCase() //2019-07-03
				this.LicenseplateQuery(v) //2019-07-03
			},
			handlePhoneSearch(value) {
				this.PhoneQuery(value)
			},
			//2019-07-03
			getLicenseplateInfo(strlicens) {
				//车牌
				if (this.phoneORlicense === 'true') {
					//获取车牌号码input的值
					getLicenseplateInfo({
						licenseplate: strlicens
					}).then(res => {
						if (res.status === 0) {
							if (res.result != null && JSON.stringify(res.result) != '{}') {
								var strMes = '入场时间：' + res.result.createdate + ',    已停时长：' + MillisecondToDate(res.result.parkingtime)
								this.extraLicenseInfo = strMes
							} else {
								this.extraLicenseInfo = '未查询到车辆信息'
							}
						}
					})
				}
			},
			//2019-07-03
			getLicenseplateInfoByMobile(strMobile) {
				//手机号
				if (this.phoneORlicense === 'false') {
					//获取手机号码input的值
					//var phone = this.$refs.phone.value
					getLicenseplateInfoByMobile({
						mobile: strMobile,
						islicenseplate: false
					}).then(res => {
						if (res.status === 0) {
							if (res.result != null && res.result != {}) {
								var strMes =
									'入场时间：' + res.result.createdate + ',    已停时长：' + MillisecondToDate(res.result.parkingtime)
								this.extraLicenseInfo = strMes
							} else {
								this.extraLicenseInfo = '未查询到车辆信息'
							}
						}
					})
				}
			},
			onChange(e) {
				this.extraLicenseInfo = '暂无车辆信息';
				if (this.phoneORlicense === 'false') {
					this.loadNullData = this.loadPhoneData
				}
			},
			handleSelectChange(e) {
				this.couponID = e
				this.spinning_lod = true
				// this.resetForm() //2019-07-03
				this.getCouponsInfo(e);

			},
			getCouponsInfo(id) {
				getCouponsInfo({
					id: id
				}).then(res => {
					if (res.status == 0) {
						this.spinning_lod = false
						this.couponInfo = res.result;

						if (this.phoneORlicense !== 'false') {
							if (this.couponInfo.isneedorders == 0) {
								this.isShow = true;
							} else {
								this.isShow = false;
							}
						} else {
							if (this.couponInfo.isneedorders == 0) {
								this.isShow = true;
							} else {
								this.isShow = false;
							}
						}

					} else {
						this.spinning_lod = false
						this.$notification['error']({
							message: '错误',
							description: ((err.response || {}).data || {}).message || '错误代码：' + res.status + '，请稍后再试',
							duration: 4
						})
						this.couponInfo = {}
					}
				})
			},
			//2019-07-03
			inputhandlePhoneChange(e) {
				//var strMobile = this.inputMobile
				var v = e.target.value;
				this.searchData = {};
				if (v.length == 11) {
					this.getLicenseplateInfoByMobile(v) //2019-07-03
				}
			},
			handlePhoneChange(e) {
				if (e.length == 11) {
					this.getLicenseplateInfoByMobile(e) //2019-07-03
				}
			},
			//2019-07-03
			inputhandleLicenseChange(e) {
				//var strMobile = this.inputMobile
				this.searchData = {};
				var v = e.target.value
				//验证车牌号
				let reg =
					/^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/


				if (v.length == 7 || v.length == 8) {
					if (reg.test(v)) {
						console.log('车牌号：' + v + ',正确.');
					} else {
						console.log('车牌号：' + v + ',错误.');
					}
					this.getLicenseplateInfo(v) //2019-07-03
				} else if (v.length > 8) {
					alert('车牌号：' + v + ',错误.');
				} else {
					this.extraLicenseInfo = '未查询到车辆信息' //2019-07-03
				}
			},
			handleLicenseChange(e) {
				this.getLicenseplateInfo(e) //2019-07-03
			},
			resetForm() {
				this.form.resetFields();
				this.couponInfo = {};
				this.extraLicenseInfo = '暂无车辆信息';
				this.searchData = {};
			},
			handleGoBack() {
				this.$emit('onGoBack')
			},
			//提交后进入方法
			handleSubmit(e) {
				var VM = this
				//阻止表单默认事件
				e.preventDefault()
				this.form.validateFields((err, values) => {
					if (!err) {
						this.$confirm({
							title: '确认提交?',
							onOk() {
								const data = {
									'uCoupons.u_parkingarea_id': VM.couponInfo.u_parkingarea_id,
									'uCoupons.u_couponsetting_id': VM.couponInfo.u_couponsetting_id,
									'uCoupons.licenseplate': values.licens,
									'uCoupons.phone': values.phone,
									'uCoupons.allcount': 1,
									'uCoupons.memo': values.memo
								}
								AddCoupons(data).then(res => {
									if (res.status === 0) {
										notification.success({
											message: '提交成功！',
											description: '页面将在1秒后自动重置'
										})
										setTimeout(() => {
											VM.resetForm()
										}, 1000)
									} else {
										notification.error({
											message: '提交失败！',
											description: res.message
										})
									}
								})
							},
							onCancel() {}
						})
					}
				})
			},
			timeFn(a, b) {
				return timeFn(a, b);
			},
			//2019-07-03
			handleConfirmPhone(rule, value, callback) {
				//关于获取字段值https://laracasts.com/discuss/channels/vue/can-i-get-an-input-value-with-vue
				if (value && !/^1\d{10}$/.test(value)) {
					callback('请输入正确的手机号！')
				}
				this.extraLicenseInfo = '未查询到车辆信息' //2019-07-03
				// Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
				callback()
			}
		}
	}
</script>

<style>
	.disabledStyle {
		background-color: #fff;
		color: #999;
	}

	.ant-card-extra {
		float: right;
		padding: 12px 0;
		/* font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      font-weight: normal; */
		margin-left: auto;
	}

	.relocdIcon {
		margin-left: 20px;
		font-size: 15px;
	}
</style>
